var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTierAccessLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 62.5C59.375 57.3219 55.1781 53.125 50 53.125C44.8219 53.125 40.625 57.3219 40.625 62.5C40.625 65.2656 41.8469 67.725 43.75 69.4438V78.125H56.25V69.4438C58.1531 67.725 59.375 65.2656 59.375 62.5Z",
    fill: "#000044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 21.875C40.625 16.7062 44.8312 12.5 50 12.5C55.1688 12.5 59.375 16.7062 59.375 21.875V26.1313C63.8781 27.1969 68.0906 29.0031 71.875 31.4281V21.875C71.875 9.81563 62.0594 0 50 0C37.9406 0 28.125 9.81563 28.125 21.875V31.4281C31.9094 29.0031 36.1219 27.1969 40.625 26.1313V21.875Z",
    fill: "#000044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43.75C60.9969 43.75 70.1 51.9188 71.625 62.5H84.2157C82.6313 45.0062 67.9 31.25 50 31.25C32.1 31.25 17.3688 45.0062 15.7844 62.5H28.375C29.9 51.9188 39.0032 43.75 50 43.75Z",
    fill: "#FC3165"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87.5C39.0032 87.5 29.9 79.3312 28.375 68.75H15.7844C17.3688 86.2438 32.1 100 50 100C67.9 100 82.6313 86.2438 84.2157 68.75H71.625C70.1 79.3312 60.9969 87.5 50 87.5Z",
    fill: "#FC3165"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTierAccessLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-tier-access-light.c99cea76342a2f7b9ff70f4bace5b46f.svg";